module.exports = __webpack_public_path__ + "d515cdca678ae9c72a84c515bc85b9f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/send.png
// module id = 880
// module chunks = 3